export{SkeletonLoaderComponent}from"./skeleton-loader.component.js";
//# sourceMappingURL=index.js.map
